module.exports = __webpack_public_path__ + "static/img/product-11.8cc4f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-11.png
// module id = 2kcb
// module chunks = 0